import { Outlet } from 'react-router-dom'
import { FaCog, FaSignOutAlt, FaUser } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../../supabaseClient'
import EmployeeTabs from './tabs'

export default function Dashboard() {
  console.log('Employee Dashboard - User arrived here');
  const navigate = useNavigate();
  
  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/');
  };
  
  return (
    <div className="dashboard-container">
      {/* Header */}
      <div className="dashboard-header">
        <div className="header-content">
          <div className="logo-section">
            <div className="logo-icon">
              <FaCog />
            </div>
            <h1>Panel de Empleado</h1>
          </div>
          <div className="header-actions">
            {/* Ícono de perfil que redirige a editProfile */}
            <button 
              onClick={() => navigate('/perfil')} 
              className="profile-button"
              title="Editar Perfil"
              style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: '1rem' }}
            >
              <FaUser />
            </button>

            <button onClick={handleLogout} className="logout-button">
              <FaSignOutAlt />
              Cerrar Sesión
            </button>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="tabs-container">
        <div className="tabs">
          <EmployeeTabs />
        </div>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        <div className="animate-fade-in">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
